import React, { useEffect, useState } from "react";
import Select from "react-select";
import Header from "../../../components/header";
import { GetTravelById, UpdateTravel } from "../services/Insert&UpdateTravel";
import { formatInTimeZone } from "date-fns-tz";
import { useValidateProductionInputs } from "../../../hooks/useValidateProductionInputs";
import Swal from "sweetalert2";

const LoadEditorUpdateModal = ({
  setShowModal,
  travel_id,
  configInputs,
  allTruckList,
  allShovelList,
  allOriginList,
  allDestinationList,
  allMaterialList,
  allTravelTypes,
  allMaterialBlock,
  allMaterialClass,
  allPitLevel,
  allRehandle,
}) => {
  const [timeStamp, setTimeStamp] = useState(null);
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [selectedShovel, setSelectedShovel] = useState(null);
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [selectedMaterialBlock, setSelectedMaterialBlock] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [selectedMaterialClass, setSelectedMaterialClass] = useState(null);
  const [selectedPitLevel, setSelectedPitLevel] = useState(null);
  const [selectedRehandle, setSelectedRehandle] = useState(null);
  const [selectedDensity, setSelectedDensity] = useState(null);
  const [selectedGrade1, setSelectedGrade1] = useState(0);
  const [selectedGrade2, setSelectedGrade2] = useState(0);
  const [selectedDistance, setSelectedDistance] = useState(null);
  const [selectedSimilarTravels, setSelectedSimilarTravels] = useState(0);

  useEffect(() => {
    (async () => {
      initializeTravelInfo();
    })();
  }, []);

  const initializeTravelInfo = async () => {
    const result_travel = await GetTravelById(travel_id);
    if (!result_travel && !result_travel.travel_info) {
      setShowModal(false);
      return;
    }
    //console.log(result_travel);
    const result_travel_info = result_travel.travel_info[0];
    //console.log(result_travel_info);
    setSelectedGrade1(result_travel_info.grade_1);
    setSelectedGrade2(result_travel_info.grade_2);
    setSelectedOrigin({
      value: result_travel_info.origin_location_id,
      label: result_travel_info.origin,
    });
    setSelectedDestination({
      value: result_travel_info.destination_location_id,
      label: result_travel_info.destination,
    });
    setSelectedShovel({
      value: result_travel_info.equipment_c_id,
      label: result_travel_info.shovel,
    });
    setSelectedMaterial({
      value: result_travel_info.material_id,
      label: result_travel_info.material_name,
    });
    setSelectedMaterialBlock({
      value: result_travel_info.block_names_record_id,
      label: result_travel_info.material_block_name,
    });
    setSelectedMaterialClass({
      value: result_travel_info.material_class_id,
      label: result_travel_info.material_class,
    });
    setSelectedPitLevel({
      value: result_travel_info.pit_level_material_id,
      label: result_travel_info.pit_level_material,
    });
    setSelectedTruck(result_travel_info.equipment);
    let formatted_timeStamp = await formatInTimeZone(
      new Date(result_travel_info.stamp_datetime),
      "UTC",
      "yyyy-MM-dd HH:mm:ss"
    );
    setTimeStamp(formatted_timeStamp);

    let value_rehandle = "False";
    let label_rehandle = "False";
    if (result_travel_info.rehandle == 1) {
      value_rehandle = "True";
      label_rehandle = "True";
    }
    setSelectedRehandle({ value: value_rehandle, label: label_rehandle });
    setSelectedSimilarTravels(result_travel.total_similar_travels);
  };
  const handleShowModal = () => {
    setShowModal(false);
  };

  const travelUpdateCall = async (is_all_travels) => {
    const inputs_update = {
      origin: selectedOrigin.value,
      destination: selectedDestination.value,
      shovel: selectedShovel.value,
      material: selectedMaterial.value,
      rehandle: selectedRehandle?.value,
      material_block: selectedMaterialBlock?.value,
      material_class: selectedMaterialClass?.value,
      pit_level: selectedPitLevel?.value,
      density: selectedDensity,
      grade1: selectedGrade1,
      grade2: selectedGrade2,
    };
    //console.log("El valor del update_all es:", is_all_travels);
    const result_update = await UpdateTravel(
      inputs_update,
      is_all_travels,
      configInputs,
      travel_id
    );
    //console.log(result_update);
    if (result_update.status == 200) {
      const result_update_m = await Swal.fire({
        title: "Travels was updated",
        icon: "success",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
        customClass: {
          confirmButton:
            "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
        },
        buttonsStyling: false,
      });

      if (result_update_m.isConfirmed) {
        setShowModal(false)
      }
    }
  };

  const UpdateRegisters = async () => {
    //console.log("Se va a actualizar el registro");
    const inputs_check = {
      origin: selectedOrigin,
      destination: selectedDestination,
      shovel: selectedShovel,
      material: selectedMaterial,
      rehandle: selectedRehandle,
      material_block: selectedMaterialBlock,
      material_class: selectedMaterialClass,
      pit_level: selectedPitLevel,
      density: selectedDensity,
      grade1: selectedGrade1,
      grade2: selectedGrade2,
    };
    const result_validate = useValidateProductionInputs(
      configInputs,
      inputs_check
    );
    //console.log(result_validate);
    if (result_validate.length > 0) {
      let result_error = await Swal.fire({
              title: "Conflicts when update travels",
              icon: "error",
              text: "All fields must be entered",
              confirmButtonColor: "#3085d6",
              customClass: {
                confirmButton:
                  "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
              },
              buttonsStyling: false,
            });
    } else {
      const { value: choice } = await Swal.fire({
        title: "Update Travels",
        html: `
          <p>There are ${selectedSimilarTravels} travels with similar info.</p>
          <p>What do you want to do?</p>
          <div class="flex gap-2 mt-4 justify-center">
            <button id="btn-all" class="swal2-confirm swal2-styled bg-blue-500">Update All</button>
            <button id="btn-one" class="swal2-cancel swal2-styled bg-green-500">Only This</button>
            <button id="btn-cancel" class="swal2-cancel swal2-styled bg-red-600">Cancel</button>
          </div>
        `,
        showConfirmButton: false,
        showCancelButton: false,
        didOpen: () => {
          const popup = Swal.getPopup();
          popup.querySelector("#btn-all").addEventListener("click", () => {
            travelUpdateCall(true);
            Swal.close();
          });
          popup.querySelector("#btn-one").addEventListener("click", () => {
            travelUpdateCall(false);
            Swal.close();
          });
          popup.querySelector("#btn-cancel").addEventListener("click", () => {
            Swal.close();
          });
        },
      });
    }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-gray-100 rounded-lg w-full max-w-3xl shadow-lg">
        <Header title={"Edit Travels"} />
        <div className="mt-22">
          <div class="mx-2 my-5 grid grid-cols-2 gap-4">
            <div class="col-span-1">
              <label class="tracking-wide  text-lg font-bold mb-2">
                Truck: {selectedTruck}
              </label>
            </div>
            <div class="col-span-1">
              <label class="tracking-wide text-lg font-bold mb-2">
                Time stamp: {timeStamp}
              </label>
            </div>
          </div>
          <div class="m-10 grid gap-4  grid-cols-[repeat(auto-fit,minmax(150px,1fr))]">
            <div class="col-span-2">
              <label class="tracking-wide  text-s font-bold mb-2">Origin</label>
              <Select
                value={selectedOrigin}
                onChange={setSelectedOrigin}
                options={allOriginList}
              />
            </div>
            <div class="col-span-2">
              <label class="tracking-wide text-s font-bold mb-2">
                Destination
              </label>
              <Select
                value={selectedDestination}
                onChange={setSelectedDestination}
                options={allDestinationList}
              />
            </div>
            <div class="col-span-2">
              <label class="tracking-wide  text-s font-bold mb-2">Shovel</label>
              <Select
                value={selectedShovel}
                onChange={setSelectedShovel}
                options={allShovelList}
              />
            </div>
            {configInputs.rehandle.is_show && (
              <div class="col-span-2">
                <label class="tracking-wide text-s font-bold mb-2">
                  Rehandle
                </label>
                <Select
                  value={selectedRehandle}
                  onChange={setSelectedRehandle}
                  options={allRehandle}
                />
              </div>
            )}
            {configInputs.material_block.is_show && (
              <div class="col-span-2">
                <label class="tracking-wide  text-s font-bold mb-2">
                  Block Name
                </label>
                <Select
                  value={selectedMaterialBlock}
                  onChange={setSelectedMaterialBlock}
                  options={allMaterialBlock}
                />
              </div>
            )}
            <div class="col-span-2">
              <label class="tracking-wide text-s font-bold mb-2">
                Material
              </label>
              <Select
                value={selectedMaterial}
                onChange={setSelectedMaterial}
                options={allMaterialList}
              />
            </div>

            {configInputs.material_class.is_show && (
              <div class="col-span-2">
                <label class="tracking-wide  text-s font-bold mb-2">
                  Material Class
                </label>
                <Select
                  value={selectedMaterialClass}
                  onChange={setSelectedMaterialClass}
                  options={allMaterialClass}
                />
              </div>
            )}

            {configInputs.pit_level.is_show && (
              <div class="col-span-2">
                <label class="tracking-wide text-s font-bold mb-2">
                  Pit Level
                </label>
                <Select
                  value={selectedPitLevel}
                  onChange={setSelectedPitLevel}
                  options={allPitLevel}
                />
              </div>
            )}
            {configInputs.grade1.is_show && (
              <div class="col-span-2">
                <label class="tracking-wide  text-s font-bold mb-2">
                  Grade 1
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="min_time_id"
                  type="number"
                  placeholder="0"
                  step={"0.01"}
                  value={selectedGrade1}
                  onChange={(e) => setSelectedGrade1(Number(e.target.value))}
                />
              </div>
            )}
            {configInputs.grade2.is_show && (
              <div class="col-span-2">
                <label class="tracking-wide text-s font-bold mb-2">
                  Grade 2
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="grid-first-name"
                  type="number"
                  placeholder="0"
                  step={"0.01"}
                  value={selectedGrade2}
                  onChange={(e) => setSelectedGrade2(Number(e.target.value))}
                />
              </div>
            )}
            <div class="col-span-2">
              <label class="tracking-wide  text-s font-bold mb-2">
                Similar Travels
              </label>
              <input
                class="appearance-none block w-full text-gray-700 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="min_time_id"
                type="number"
                placeholder="0"
                disabled="true"
                value={selectedSimilarTravels}
              />
            </div>
          </div>
          <div class="mx-2 my-5 grid grid-cols-2 gap-4">
            <div class="col-span-1">
              <button
                className="w-4/5 bg-red-500 text-white px-4 py-2 rounded mr-2"
                onClick={handleShowModal}
              >
                Cancel
              </button>
            </div>
            <div class="col-span-1">
              <button
                className="w-4/5 bg-blue-500 text-white px-4 py-2 rounded"
                onClick={UpdateRegisters}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadEditorUpdateModal;
